module.exports = __webpack_public_path__ + "static/media/feedback.14cc7c49.svg";